.bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-6);
  border-top: 1px solid var(--color-border);
}

.summary {
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
}

.pages {
  display: flex;
  align-items: center;
  gap: var(--space-1);
}

.page {
  min-width: var(--control-height-sm);
  height: var(--control-height-sm);
  padding: 0 var(--space-2);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  background: none;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-2);
}

.page:hover {
  background-color: var(--color-surface-2);
}

.current,
.current:hover {
  background-color: var(--color-accent);
  color: var(--color-on-accent);
}

.gap {
  padding: 0 var(--space-1);
  color: var(--color-text-muted);
}
